import { getTemplate } from "../template-helper.js";

const COMPONENT_NAME = "z-chart" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    return getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ChartComponent extends HTMLElement {
            constructor() {
                super();

                //allow value to be an array
                this.isArrayContainer = true ;
                
            }

            connectedCallback(){
                this.init() ;
            }


            init(){
                this.div = this.querySelector(".z-chart-container") ;
                if(!this.div){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    this.div = this.querySelector(".z-chart-container") ;
                }


                const rootNode = this.getRootNode();
                if(!rootNode || !rootNode.getElementById){ 
                    return  ;
                }

                this.doImport().then(()=>{
                    this.renderChart() ;
                }) ;
            }

            formatValue(){
                return (this.currentValue||[]).map(r=>{
                    let value = Number(r.count||r.sum) ;
                }) ;
            }

            renderChart(){
                if(!this.chart){
                    var canvas = document.createElement('canvas') ;
                    canvas.style.height= "100%" ;
                    this.div.appendChild(canvas) ;
                    
                    var chartOptions = {
                        responsive: true,
                        maintainAspectRatio: false,
                    };
                    var option = {
                        type: "doughnut",
                        options: chartOptions
                    } ;
            
                    var values = [] ;
                    var labels = [] ;
                    var colors = [] ;
                    var data = {
                        datasets: [{
                            data: values,
                            backgroundColor: colors
                        }],
                        labels: labels,
                    } ;
                    option.data = data;
    
                    if(this.currentValue){
                        data.labels = this.currentValue.map(function(v){ return  v.name; });
                        data.datasets[0].data = this.currentValue.map(function(v){ return  v.value; });
                    }
    
                    chartOptions.title = { display: true, text: "Titre", position:'top', fontSize: 14 } ;
    
                    this.chart = new window.Chart(canvas, option) ;
                }else{
                    if(this.currentValue){
                        this.chart.data.labels = this.currentValue.map(function(v){ return  v.name; });
                        this.chart.data.datasets[0].data = this.currentValue.map(function(v){ return  v.value; });
                        this.chart.update();
                    }
                }
            }

            doImport() {
                let rootNode = this.getRootNode();
                if(rootNode === this) { return Promise.resolve(); }
                if(!rootNode || !rootNode.getElementById){ return Promise.resolve(); }

                let head = rootNode;
                if(rootNode.head){
                    head = rootNode.head ;
                }

                const styleTag = rootNode.getElementById("style_z_chart") ;
                if(styleTag){ return rootNode.importChartPromise; }

                var sInline = document.createElement('style');
                sInline.id = "style_z_chart" ;
                sInline.setAttribute('type', 'text/css');
                sInline.appendChild(document.createTextNode(`
                    
                `));
                head.appendChild(sInline);
                
                rootNode.importChartPromise = new Promise((resolve, reject)=>{
                    let script = document.createElement("script");
                    script.async = true;
                    script.type = "text/javascript";
                    script.src = "/node_modules/chart.js/dist/Chart.min.js";
                    script.onload = function(_, isAbort) {
                        if (!script.readyState || "complete" === script.readyState) {
                            if (isAbort){
                                reject("can't load chart.js") ;
                            }else{
                            resolve() ;
                            }
                        }
                    } ;
                        
                    script.onreadystatechange = script.onload ;
                    
                    script.onerror = function () {
                        reject("can't load leaflet") ;
                    };
                    
                    head.appendChild(script);
                });
                                            
                                         
                return rootNode.importChartPromise;
            }

            get value(){
                return this.currentValue;
            }
            set value(value){
                this.currentValue = value;
                if(this.chart){
                    this.renderChart(); 
                }
            }

            get type(){
                return this.getAttribute("z-type");
            }
            set type(type){
                this.setAttribute("z-type", type);
            }

            static get observedAttributes() {
                return ["z-type"];
            }

            // attributeChangedCallback(name, oldValue, newValue) {
            //     switch (name) {
            //         case 'z-center-coords':
            //         case 'z-zoom':
            //             this.applyCoordsAndZoom();
            //             break;
            //         case 'z-tile-provider':
            //             this.renderLayer();
            //             break;
                   
            //     }
            // }
           
        }
        customElements.define(COMPONENT_NAME, ChartComponent);

    }).catch((err)=>{
        throw err ;
    }) ;
}
